/**
 * Deprecated: redirect to /reset-password
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/forgot-password")({
  beforeLoad: async () => {
    throw redirect({ to: "/reset-password" });
  },
  component: () => null,
});
